import styled from 'styled-components';
import ThemedTooltip from '../../../theme/ThemedTooltip';
import { svgCenteredText } from '../../../theme/typography';

export const StyledInnerCircle = styled.circle`
  fill: none;
  filter: none;
`;

export const StyledCircle = styled.circle`
  stroke-dasharray: ${({ strokeDasharray }) =>
    strokeDasharray}; /* this value is the pixel circumference of the circle */
  stroke-dashoffset: ${({ offset }) => `${offset}`};
  transition: 0.35s stroke-dashoffset;
  fill: none;
`;

export const StyledLabelSvg = styled.svg`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  transform: none;
  pointer-events: none;
  overflow: visible;
`;

export const StyledLabelText = styled.text.attrs({
  textAnchor: 'middle',
  dy: '0.35em',
})`
  ${svgCenteredText};
  fill: ${({ theme }) => theme.text};
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  font-size: ${({ $small }) => ($small ? '9px' : '11px')};
`;

export const StyledWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 3px;
  width: ${({ small }) => (small ? '22px' : '42px')};
  height: ${({ small }) => (small ? '22px' : '42px')};

  svg.donut-ring {
    display: block;
    width: 100%;
    height: 100%;
    transform: scale(-1, 1) rotate(-90deg);
    overflow: visible;
  }

  .circle_animation {
    stroke-dasharray: 360 360; /* this value is the pixel circumference of the circle */
    stroke-dashoffset: 360;
  }
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  text-align: center;
  border: solid 0.5px #e1e1e1;
  min-width: 85px;
  &.__react_component_tooltip.show {
    background-color: #000;
    font-size: 11px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledHoverPlaceholder = styled.div`
  display: none;
  position: relative;
  flex-direction: row;
  align-items: center;
  color: #fff;
  background-color: #3164fb;
  border-radius: 50%;
  justify-content: center;
  font-size: 9px;
  width: 21px;
  height: 21px;
`;
